import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the get-timezone endpoint.
 */
export function buildGetTimezoneConfig(
  latitude: number,
  longitude: number,
  user_uuid: string,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.GET_TIMEZONE,
    body: { latitude, longitude, user_uuid },
  };
}
